import React, { useEffect, useMemo, useState } from "react";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import VirtualTable from "../ui/VirtualTable";
import { useTabs } from "../hooks/useTabs";
import Input from "../ui/Input";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Spin from "../ui/Spin";
import EnumField from "../ui/EnumField";
import Space from "../ui/Space";
import { drawPicker } from "../popovers/Picker";

export default function SetupPOS(props) {
    const { controller = "", route = "", callback = () => { } } = props;

    const [settings, setSettings] = useState({});
    const [selected, setSelected] = useState({});
    const [fieldMode, setFieldMode] = useState(false);
    const [loading, setLoading] = useState(false);

    const row_key = "key";

    const columns = [
        { key: "letter", title: <></>, align: "left", width: 20 },
        { key: "display", title: <></>, align: "left", width: 100, grow: true },
    ];

    const { tabs, setTabs, index, help, update, setIndex, editProps, next, prev, refs, getVal } = useTabs([], "");

    const getSettings = () => {
        setLoading(true)
        pubCall("setting.point_of_sale.getSettings", {}, (_s, _r) => {
            if (_s) {
                setSettings(_r || {});
            } else {
                showError(_r);
            }
            setLoading(false)
        });
    };

    useEffect(getSettings, []);



    const getTenderOptions = () => {
        pubCall("setting.point_of_sale.getDefaultTenderOptions", {}, (_s, _r) => {
            if (_s) {
                drawPicker({
                    controller: controller,
                    title: "Select Tender Option", closeable: true, height: 300, route: route, callback: (e) => {
                        if (e) {
                           let _default_tender = _r.find(item => item.number === e);
                           setSettings({...settings, "default_tender" : _default_tender})
                        }
                    }, offset: [0, 10],
                    options: _r.map(item => {
                        return {
                            label: item.name,
                            value: item.number
                        }
                    })
                })
            } else {
                showError(_r)
            }
        })
    }


    const rows = useMemo(() => {
        return [
            {
                key: "customer_formats",
                letter: "A",
                fields: [
                    {
                        key: "default_customer_linked_document_format",
                        value: settings?.default_customer_linked_document_format || "",
                        skip: false,
                    },
                    {
                        key: "default_customer_linked_on_acct_document_format",
                        value: settings?.default_customer_linked_on_acct_document_format || "",
                        skip: false,
                    },
                ],
            },
            {
                key: "default_tender",
                letter: "B",
                fields: [],
                action: () => getTenderOptions(),
            },
            {
                key: "station_group",
                letter: "C",
                fields: [
                    {
                        key: "station_group",
                        value: settings?.station_group || "",
                        skip: false,
                    },
                ],
            },
            // {
            //     key: "save",
            //     letter: "S",
            //     fields: [],
            //     action: () => save(),
            // },
        ];
    }, [settings]);

    useEffect(() => {
        if (!selected?.key && rows.length) {
            setSelected(rows[0]);
        }
    }, [rows, selected?.key]);

    const save = () => {
        const _obj = {};

        tabs.forEach((tab) => {
            _obj[tab.key] = getVal(tab.key);
        });

        console.log(settings)

        return;

        setLoading(true)
        pubCall("setting.point_of_sale.saveSettings", _obj, (_s, _r) => {
            if (_s) {
                showMessage("Settings saved");
                callback();
            } else {
                showError(_r);
            }
            setLoading(false)
        });
    };

    const blurField = (_field = index) => {
        const el = refs.current[_field];

        if (el && typeof el.blur === "function") {
            el.blur();
        }
    };

    const focusField = (_field = index) => {
        const el = refs.current[_field];

        if (el && typeof el.focus === "function") {
            el.focus();
        }
    };

    const rowNext = () => {
        if (fieldMode) {
            return;
        }

        const i = rows.findIndex((r) => r.key === selected?.key);
        const nextRow = rows[Math.min(i + 1, rows.length - 1)];

        if (nextRow) {
            setSelected(nextRow);
        }
    };

    const rowPrev = () => {
        if (fieldMode) {
            return;
        }

        const i = rows.findIndex((r) => r.key === selected?.key);
        const prevRow = rows[Math.max(i - 1, 0)];

        if (prevRow) {
            setSelected(prevRow);
        }
    };

    const enterRow = () => {
        const row = selected;

        if (!row) {
            return;
        }

        if (!row.fields?.length) {
            row.action?.();
            return;
        }

        setTabs(row.fields);
        setIndex(row.fields[0].key);
        setFieldMode(true);

        requestAnimationFrame(() => {
            focusField(row.fields[0].key);
        });
    };

    const exitFieldMode = () => {
        blurField(index);
        setFieldMode(false);
    };

    const renderInput = (key, width = 40) => {
        return (
            <Input
                {...editProps(key)}
                width={width}
                edit={fieldMode && selected?.fields?.some((f) => f.key === key)}
                disabled={!fieldMode}
            />
        );
    };

    const data = rows.map((row) => {
        if (row.key === "customer_formats") {
            return {
                ...row,
                display: (
                    <div>
                        Sales are started with cursor in the  <span style={{ display: "inline-block", width: "60px", verticalAlign: "middle" }}><EnumField className={"fill"} style={{ "height": "26px" }} width={60} {...editProps("default_customer_linked_document_format")} edit={fieldMode && selected?.fields?.some((f) => f.key === "default_customer_linked_document_format")} options={[{ value: "I", key: KBD.I, label: "ISBN" }, { value: "S", key: KBD.S, label: "Shipto" }]} /></span>
                    </div>
                ),
            };
        }
        if (row.key === "default_tender") {

            let _tender  = getVal("default_tender");
            return {
                ...row,
                display: (
                    <div>
                        Sales (not linked to a customer) default to tender {settings?.default_tender?.name || ""}
                    </div>
                ),
            };
        }



        return row;
    });

    const actions = [
        {
            key: KBD.ESCAPE,
            action: () => {
                if (fieldMode) {
                    exitFieldMode();
                    return;
                }

                callback();
            },
        },
        {
            key: KBD.ENTER,
            action: () => {
                if (!fieldMode) {
                    enterRow();
                    return;
                }

                next();
            },
        },
        {
            key: KBD.ARROW_DOWN,
            action: () => {

                if (fieldMode) {
                    next();
                    return;
                }

                rowNext();
            },
        },
        {
            key: KBD.ARROW_UP,
            action: () => {
                if (fieldMode) {
                    prev();
                    return;
                }

                rowPrev();
            },
        },
        {
            key: KBD.PAGE_DOWN,
            action: () => save(),
        },
    ];

    useEffect(() => {
        const cleanup = listen(
            controller,
            route,
            actions,
            false,
            [
                KBD.ENTER,
                KBD.ARROW_DOWN,
                KBD.ARROW_UP,
                KBD.PAGE_DOWN,
                KBD.PAGE_UP,
                KBD.ESCAPE,
                KBD.MINUS,
            ]
        );

        return cleanup;
    }, [controller, route, selected, fieldMode, index, tabs]);


    useEffect(() => {
        if (fieldMode) {
            refs?.current?.[index]?.focus?.();
        }
    }, [index])

    return (
        <div style={{ "width": "800px" }}>
            {index}
            <Spin>
                <VirtualTable
                    no_header_borders={true}
                    controller={controller}
                    onRowClick={(item) => {
                        if (fieldMode) {
                            return;
                        }

                        setSelected(item);
                    }}
                    next={rowNext}
                    prev={rowPrev}
                    align={"bottom"}
                    row_key={row_key}
                    current={selected}
                    data={data}
                    height={500}
                    columns={columns}
                    width={0}
                    offset={130}
                    route={route}
                    scrollbar={true}
                    scrollindicator={true}
                    infinite={true}
                />
            </Spin>
        </div>

    );
}